<div class="error-dialog">
  <h4>Please resolve the following Errors:</h4>
  <div class="error-text" *ngFor="let error of errors, let i = index">{{i + 1}}. {{error}}</div>
  <div class="ok-button">
    <button type="button" mat-raised-button color="primary" (click)="dialogRef.close()">OK</button>
  </div>
</div>
